export default "__VITE_ASSET__f324a37a__"